var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      class: _vm.classes,
      on: {
        mouseenter: _vm.mouseEnter,
        mouseleave: _vm.mouseLeave,
        touchstart: _vm.touchStart,
        touchend: _vm.touchEnd
      }
    },
    [
      _c(
        "span",
        { ref: "trigger", staticClass: "vt-trigger" },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "vt-tip-anchor", style: _vm.anchorStyle },
        [
          _c("transition", { attrs: { name: "vt-tip-fade" } }, [
            _vm.active
              ? _c("span", { staticClass: "vt-tip", style: _vm.tipStyle }, [
                  _c("span", { staticClass: "vt-content" }, [_vm._t("tip")], 2)
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "vt-arrow-fade" } }, [
            _vm.active ? _c("span", { staticClass: "vt-arrow" }) : _vm._e()
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bc4ed894", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc4ed894","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tip.vue
// module id = eZIJ
// module chunks = 0